function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M132 185a4 4 0 004 2 4 4 0 003-2 4 4 0 011-1 8 8 0 001 0 6 6 0 005-4l1 4c1 6 10 4 10-2 1-7 0-20-6-26a6 6 0 00-5-3 12 12 0 00-3 0c-8 1-9 7-10 14v2a18 18 0 000 11 7 7 0 00-1 5zm12-15l1 5a5 5 0 00-1-2 31 31 0 010-3z",
  fill: "#9df3f0"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M113 140l-1 43a4 4 0 003 3h1a4 4 0 003-2v-1a3 3 0 000-3l-5-40a1 1 0 00-1 0zm44 15c-2 5 1 12 1 17 0 4-1 9 1 12 2 4 8 0 5-3l-1-11c-1-5-2-11-5-16l-1 1zm-75-54h2c-2 1-2 7 2 6 2 3 8 2 11 2a32 32 0 007 0c4-1 6-4 8-7a3 3 0 001-1l3-2a2 2 0 00-1-3c-11-1-22 3-33 4a1 1 0 000 1zm20-1h-5l-9 1 14-1zm80 11a36 36 0 0012 1 3 3 0 001 0c4 1 9-5 12-8 2-2 0-5-3-5a102 102 0 01-10 2l-16 2a1 1 0 00-1 1 14 14 0 00-2-1l-1 1c2 3 4 6 8 7zm-78 50c-1 8-2 16-1 23 1 5 8 3 8-2l-2-20v-11c0-3-2-8-1-11a1 1 0 001-2l-2-28a1 1 0 00-1 0v28a1 1 0 001 1 30 30 0 00-2 9l-1 13zm91 21c-1 4 8 5 8 0-1-23 0-46-3-69h-1c-2 11 0 23-1 34l-3 35zm-96-50l1-1a11 11 0 002-1c0-1 0-3-2-2v-1a3 3 0 00-1-4 3 3 0 00-4 1c-2 3-2 7 0 9a3 3 0 004-1zm92-8a5 5 0 00-4 4 7 7 0 004 6 3 3 0 004-1 6 6 0 001-4 3 3 0 00-4-2 2 2 0 00-1-3z",
  fill: "#e0dfe6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M88 78a2 2 0 00-2-1h-8a2 2 0 00-2 2v22a2 2 0 001 1l2 2 5 5v24l2 31 1 22h-8a2 2 0 000 3 1305 1305 0 0047-1h4l29-1a577 577 0 0153 0 2 2 0 100-3h-7v-25l-1-24v-15l-1-9 6-5 2-2a2 2 0 000-1V80a2 2 0 00-1-1h-7a1 1 0 00-1 0 2 2 0 00-1 1v9h-5v-9a2 2 0 00-1-2h-8a1 1 0 00-1 1 2 2 0 00-1 1v10h-4l-1-10a2 2 0 00-1-2h-8a2 2 0 00-1 1l-1 21a2 2 0 000 1l8 10v23h-8v-8a2 2 0 00-1-1h-11a2 2 0 00-1 1v8h-6v-8a2 2 0 000-1 2 2 0 00-1 0l-7-1h-4a1 1 0 00-1 1 2 2 0 000 1v8l-7-1v-8a2 2 0 00-2-2 97 97 0 01-10 0 1 1 0 00-1 1 2 2 0 00-1 1v8h-5l-1-24 8-10a2 2 0 000-1V77a2 2 0 00-2-1h-7a2 2 0 00-2 2v9h-4v-9a2 2 0 00-2-2h-8a2 2 0 00-1 2v8h-4v-7zm56 107h-12v-6c0-10 0-20 4-25a11 11 0 017-3 715 715 0 001 34zm3 0v-1a421 421 0 00-1-33l7 2c3 4 3 12 3 21v10l-9 1zm25-85l1-19h4l1 11a2 2 0 001 1h4a27 27 0 014 0 2 2 0 001-2V81h5v9a2 2 0 000 1 2 2 0 002 1h7a2 2 0 002-1v-9h4v20l-1 2-6 5a2 2 0 00-1 1l1 10v15a902 902 0 001 49h-20l-1-21-1-52a2 2 0 000-1l-8-10zm-58 36h4a2 2 0 001-1v-9h8v9a2 2 0 002 2h9a2 2 0 002-2v-7h7v7a2 2 0 002 2h8a1 1 0 002 0 2 2 0 000-1v-8h7v7a2 2 0 002 2h9l1 26 1 21h-20v-10c0-10 0-18-4-23-2-2-5-3-9-3h-2c-4 0-7 1-10 4-6 6-5 16-5 27v6h-16l-2-46v-3zM94 89a2 2 0 001-2v-7l5-1v9a2 2 0 001 2h8a2 2 0 001 0 2 2 0 000-1V79h5v19l-7 10a2 2 0 00-1 1l1 30 2 46h-6l-14 1-1-22a365 365 0 01-2-56 2 2 0 000-1l-6-5-2-1V80h6v8a2 2 0 001 1h8z",
  fill: "#525d7d"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M91 134a2 2 0 001 1h11a2 2 0 001-2v-4c0-7-2-10-7-10-3 0-6 2-6 9v6zm6-12c4 0 4 4 4 7v3h-7v-4c0-5 2-6 3-6zm87 14a2 2 0 002 1h10a2 2 0 001-2l1-4c0-6-3-10-7-10s-7 3-7 9v6zm7-12c3 0 4 4 4 7l-1 3h-7v-4c0-5 2-6 4-6z",
  fill: "#525d7d"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M67 40c1-3-3-7-6-4-3 2-5 3-8 3a22 22 0 01-9-2c-3-1-5 3-3 6 3 3 10 5 16 5a36 36 0 005-2 11 11 0 005-6z",
  fill: "#9df3f0"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M75 24l-1 12a20 20 0 01-6 7l-6 3a36 36 0 01-5 2 25 25 0 01-8 0 26 26 0 01-10-3 23 23 0 01-5-3l-5-6a1 1 0 00-2 1 25 25 0 0019 22c11 2 25 0 32-9a6 6 0 002-4c3-7 3-17-3-23a1 1 0 00-2 1z",
  fill: "#e0dfe6"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M48 3a20 20 0 013 0 21 21 0 0119 13l3-1A24 24 0 0051 0a23 23 0 00-3 0 27 27 0 00-18 12l2 2A24 24 0 0148 3zm24 22a21 21 0 01-5 14l2 1a1 1 0 010 2 24 24 0 006-17 27 27 0 00-1-8l-3 2a24 24 0 011 6zm-6 17l-1-1a19 19 0 01-12 5c-4 0-10-1-14-5l-1 1a1 1 0 01-2 1c5 4 12 6 17 6a22 22 0 0015-7 2 2 0 01-2 0zm-31-1l1-2a21 21 0 01-7-15 17 17 0 012-7l-3-2a21 21 0 00-2 9c0 8 4 14 9 18a2 2 0 010-1zm5-7l1-1a2 2 0 012 0 11 11 0 01-4-9 9 9 0 010-2l-2-2a12 12 0 00-1 4 14 14 0 004 10zm12 2a14 14 0 01-9-3 2 2 0 010 2l-1 1a17 17 0 0010 3 13 13 0 008-3h-1a2 2 0 012-3l1 1a15 15 0 004-9 16 16 0 00-1-3l-3 2 1 1c0 6-5 11-11 11z",
  fill: "#525d7d"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M49 13a11 11 0 012 0 12 12 0 0111 8l2-2a14 14 0 00-13-9 14 14 0 00-2 0 16 16 0 00-11 7l3 2a13 13 0 018-6zM8 27l3-4 8-10a5 5 0 01-2-2L8 22l-3 3a4 4 0 013 2zm16-15l4 3 3 2 6 3 2 2 4 2 4 2a6 6 0 011-2l-4-3-3-2-3-2-6-3-2-2-5-2a4 4 0 01-1 2z",
  fill: "#525d7d"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M69 17l-5 2-2 2-6 3a4 4 0 011 3l6-3 2-2 6-3h1l2-2 10-5a5 5 0 01-2-3l-9 6-3 1zM4 33a4 4 0 004-4 3 3 0 000-2 4 4 0 00-3-2 4 4 0 00-1 0H3a4 4 0 00-1 1 4 4 0 002 7zm0-5l1 1a1 1 0 01-1 1l-1-1a1 1 0 011-1zm15-15a5 5 0 002 0 5 5 0 003-1 4 4 0 001-3 5 5 0 00-9 0 4 4 0 001 2 5 5 0 002 2zm1-6a1 1 0 011 0 2 2 0 011 2l-1 1-2-1a2 2 0 011-2z",
  fill: "#525d7d"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M84 12a5 5 0 003 1 5 5 0 005-5 3 3 0 00-1-1c0-1-1-3-4-3-3-1-5 2-5 4a4 4 0 000 1 5 5 0 002 3zm2-5l3 1a2 2 0 01-2 2 2 2 0 01-2-2l1-1zM52 32a5 5 0 005-5 4 4 0 00-1-3 5 5 0 00-3-1 5 5 0 00-1 0v-1a4 4 0 00-1 0 4 4 0 00-3 2 6 6 0 00-1 2 6 6 0 000 1 5 5 0 005 5zm-1-7a6 6 0 001 0 2 2 0 010 1 2 2 0 012 1 2 2 0 01-2 2 2 2 0 01-2-2l1-2zM38 42l1-1 1-1 2-4 1-1a2 2 0 000-2 2 2 0 00-2 0l-1 1-3 4-1 1-1 2a2 2 0 001 2 1 1 0 002-1zm30-2l-1-1-4-3-1-2-1-1a2 2 0 00-2 3h1l2 2a191 191 0 014 4 2 2 0 003 0 1 1 0 00-1-2z",
  fill: "#525d7d"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M227 171l5 1 5 1a4 4 0 005-3 2 2 0 002 0 3 3 0 102-4 3 3 0 00-4 1 4 4 0 00-4-2c-3 0-9 0-11 4a2 2 0 000 2z",
  fill: "#9df3f0"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M244 163a105 105 0 016-10 2 2 0 00-1-2h-23a2 2 0 00-2 1 736 736 0 000 34 2 2 0 001 2 2 2 0 002-2v-12l21-1h2a2 2 0 001-2 68 68 0 01-7-8zm-17 8v-17h19l-5 8a2 2 0 000 2 77 77 0 005 6l-19 1z",
  fill: "#525d7d"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M54 158a8 8 0 009-5 8 8 0 00-1-7 10 10 0 00-6-4c-2-1-5 1-6 3a6 6 0 00-3 4c-1 4 3 8 7 9z",
  fill: "#9df3f0"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M59 159a10 10 0 006-12c-1-7-9-7-13-6a12 12 0 00-1 0 9 9 0 00-6 11 11 11 0 0014 7zm-7-15a1 1 0 011 0c2-1 8-1 9 4a7 7 0 01-4 8 8 8 0 01-10-5 6 6 0 014-7z",
  fill: "#525d7d"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M55 146a1 1 0 01-1 2 1 1 0 01-1-1 3 3 0 00-1 3c0 2 3 2 4 1h2a4 4 0 01-2 2 2 2 0 01-2 0 1 1 0 00-1 2 4 4 0 003 0v-1a1 1 0 111-1l1 1c1-1 2-2 1-3 0-2-2-2-4-2h-1c-1-1 1-2 2-2a1 1 0 000-2 6 6 0 00-1 0 6 6 0 00-1 0l1 1z",
  fill: "#525d7d"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M52 145l1 2a1 1 0 001 1 1 1 0 001-2h-1v-2a1 1 0 00-2 0 1 1 0 000 1zm5 8a1 1 0 10-1 1v2a1 1 0 002-1v-1zm82-101a5 5 0 01-2-3 6 6 0 015-6 10 10 0 012 0l2-2a12 12 0 00-3-1 9 9 0 00-9 9 8 8 0 003 6v-1zm9-6a4 4 0 010 1 6 6 0 01-6 7 6 6 0 01-2-1l-1 2v1a9 9 0 003 1 9 9 0 009-10 7 7 0 000-2 7 7 0 00-3-4l-2 3a4 4 0 012 2z",
  fill: "#525d7d"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M152 33a1 1 0 00-1 0l-5 8-2 2-5 9-2 2v1l-3 5a1 1 0 002 1l3-5v-1l1-2a618 618 0 0112-19 1 1 0 000-1z",
  fill: "#525d7d"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M189 34c1 1 3-1 5-1s-3-7-1-7c3 1 21-9 20-7-1-2-6 0-8 0-5 1-14 3-17 7-1 2-1 7 1 8z",
  fill: "#e0dfe6"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M223 14h-24l-18-1h-5a1 1 0 00-1 2l8 8 1 1 1 6 2 5a1 1 0 001 1l5-1v3a31 31 0 002 4 1 1 0 001 1 1 1 0 001 0l25-25 1-1 1-1a1 1 0 000-2 1 1 0 00-1 0zm-39 7l-5-5h34l-21 4zm5 12l-3-10 7-1a1065 1065 0 00-2 3 1 1 0 00-1 1 28 28 0 002 5v2h-3zm7 7a68 68 0 01-1-6l-1-4a33 33 0 01-1-3l12-4 12-4c-7 7-14 13-20 21z",
  fill: "#525d7d"
});

var SvgStep3 = function SvgStep3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 251 189"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
};

export default SvgStep3;